import { ReportFilter } from "types/navigation/reportNavigation";

export const DEFAULT_REPORT_TABLE_SORT = { id: "name", desc: false };

export const BASE_REPORT_FILTERS: ReportFilter = {};
